import React, { useState, useEffect } from "react";
import { analyticsReport } from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import "../pages/search.css";
import { Button } from "react-bootstrap";

const Analytics_Report = () => {
  const [search, setSearch] = useState(false);
  const [searchOn, setSearchOn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState([]);
  const [toDate, setToDate] = useState([]);
  const [detail, setDetail] = useState([]);
  const [dHeader, setDHeader] = useState([]);
  const [mHeader, setMHeader] = useState([]);
  const [diam, setDiam] = useState([]);
  const [sDiam, setSDiam] = useState([]);
  const [metrics, setMetrics] = useState([]);
  const [sMetrics, setSMetrics] = useState([]);
  const [number, setNumber] = useState(0);
  const [time, setTime] = useState("");
  const lan = "ltr";

  const dData = [
    "achievementId",
    "adFormat",
    "adSourceName",
    "adUnitName",
    "appVersion",
    "audienceId",
    "audienceName",
    "brandingInterest",
    "browser",
    "campaignId",
    "campaignName",
    "character",
    "city",
    "cityId",
    "cohort",
    "cohortNthDay",
    "cohortNthMonth",
    "cohortNthWeek",
    "contentGroup",
    "contentType",
    "continent",
    "continentId",
    "country",
    "countryId",
    "date",
    "dateHour",
    "day",
    "dayOfWeek",
    "dayOfWeekName",
    "defaultChannelGroup",
    "deviceCategory",
    "eventName",
    "fileName",
    "firstSessionDate",
    "firstUserCampaignName",
    "firstUserDefaultChannelGroup",
    "firstUserGoogleAdsAccountName",
    "firstUserGoogleAdsAdGroupId",
    "firstUserGoogleAdsAdGroupName",
    "firstUserGoogleAdsAdNetworkType",
    "firstUserGoogleAdsCampaignId",
    "firstUserGoogleAdsCampaignType",
    "firstUserGoogleAdsCreativeId",
    "firstUserGoogleAdsCustomerId",
    "firstUserGoogleAdsKeyword",
    "firstUserGoogleAdsQuery",
    "firstUserMedium",
    "firstUserSourcePlatform",
    "fullPageUrl",
    "googleAdsAccountName",
    "googleAdsAdGroupName",
    "googleAdsCampaignId",
    "googleAdsCampaignName",
    "googleAdsCampaignType",
    "googleAdsCreativeId",
    "googleAdsCustomerId",
    "googleAdsKeyword",
    "googleAdsQuery",
    "groupId",
    "hostName",
    "hour",
    "isConversionEvent",
    "isoYearIsoWeek",
    "itemAffiliation",
    "itemBrand",
    "itemCategory2",
    "itemCategory3",
    "itemCategory4",
    "itemCategory5",
    "itemId",
    "itemListId",
    "itemListName",
    "itemListPosition",
    "itemLocationID",
    "itemName",
    "itemPromotionCreativeName",
    "itemPromotionCreativeSlot",
    "itemPromotionId",
    "itemPromotionName",
    "itemVariant",
    "landingPagePlusQueryString",
    "language",
    "languageCode",
    "level",
    "linkClasses",
    "linkDomain",
    "linkId",
    "linkText",
    "linkUrl",
    "manualAdContent",
    "manualTerm",
    "medium",
    "method",
    "minute",
    "mobileDeviceBranding",
    "mobileDeviceMarketingName",
    "newVsReturning",
    "nthDay",
    "nthHour",
    "nthMinute",
    "nthMonth",
    "nthWeek",
    "nthYear",
    "operatingSystem",
    "operatingSystemVersion",
    "operatingSystemWithVersion",
    "orderCoupon",
    "outbound",
    "pageLocation",
    "pagePath",
    "pageReferrer",
    "pageTitle",
    "percentScrolled",
    "platform",
    "platformDeviceCategory",
    "region",
    "screenResolution",
    "searchTerm",
    "sessionCampaignId",
    "sessionCampaignName",
    "sessionDefaultChannelGroup",
    "sessionGoogleAdsAccountName",
    "sessionGoogleAdsAdGroupId",
    "sessionGoogleAdsAdGroupName",
    "sessionGoogleAdsAdNetworkType",
    "sessionGoogleAdsCampaignId",
    "sessionGoogleAdsCampaignName",
    "sessionGoogleAdsCampaignType",
    "sessionGoogleAdsCreativeId",
    "sessionGoogleAdsCustomerId",
    "sessionGoogleAdsKeyword",
    "sessionGoogleAdsQuery",
    "sessionManualTerm",
    "sessionMedium",
    "sessionSa360AdGroupName",
    "sessionSa360CampaignId",
    "sessionSa360CampaignName",
    "sessionSa360CreativeFormat",
    "sessionSa360EngineAccountId",
    "sessionSa360EngineAccountName",
    "sessionSa360EngineAccountType",
    "sessionSa360Keyword",
    "sessionSa360Medium",
    "sessionSa360Query",
    "sessionSa360Source",
    "sessionSource",
    "sessionSourceMedium",
    "sessionSourcePlatform",
    "shippingTier",
    "signedInWithUserId",
    "source",
    "sourceMedium",
    "sourcePlatform",
    "streamId",
    "streamName",
    "testDataFilterId",
    "testDataFilterName",
    "transactionId",
    "unifiedPagePathScreen",
    "unifiedPageScreen",
    "unifiedScreenClass",
    "unifiedScreenName",
    "userAgeBracket",
    "userGender",
    "videoProvider",
    "videoTitle",
    "videoUrl",
    "virtualCurrencyName",
    "visible",
    "week",
    "year",
    "yearMonth",
    "yearWeek",
  ];

  const mData = [
    "active1DayUsers",
    "active28DayUsers",
    "active7DayUsers",
    "activeUsers",
    "adUnitExposure",
    "advertiserAdClicks",
    "advertiserAdCost",
    "advertiserAdCostPerClick",
    "advertiserAdCostPerConversion",
    "advertiserAdImpressions",
    "averagePurchaseRevenue",
    "averagePurchaseRevenuePerPayingUser",
    "averagePurchaseRevenuePerUser",
    "averageRevenuePerUser",
    "averageSessionDuration",
    "bounceRate",
    "cartToViewRate",
    "checkouts",
    "cohortTotalUsers",
    "conversions",
    "crashAffectedUsers",
    "crashFreeUsersRate",
    "dauPerMau",
    "dauPerWau",
    "ecommercePurchases",
    "engagedSessions",
    "engagementRate",
    "eventCount",
    "eventValue",
    "eventsPerSession",
    "firstTimePurchaserConversionRate",
    "firstTimePurchasers",
    "firstTimePurchasersPerNewUser",
    "itemListClickEvents",
    "itemListClickThroughRate",
    "itemListViewEvents",
    "itemPromotionClickThroughRate",
    "itemRevenue",
    "itemViewEvents",
    "itemsAddedToCart",
    "itemsCheckedOut",
    "itemsClickedInList",
    "itemsClickedInPromotion",
    "itemsPurchased",
    "itemsViewed",
    "itemsViewedInList",
    "itemsViewedInPromotion",
    "newUsers",
    "organicGoogleSearchAveragePosition",
    "organicGoogleSearchClickThroughRate",
    "organicGoogleSearchClicks",
    "organicGoogleSearchImpressions",
    "promotionClicks",
    "promotionViews",
    "publisherAdImpressions",
    "purchaseRevenue",
    "purchaseToViewRate",
    "purchaserConversionRate",
    "returnOnAdSpend",
    "screenPageViews",
    "screenPageViewsPerSession",
    "screenPageViewsPerUser",
    "scrolledUsers",
    "sessionConversionRate",
    "sessions",
    "sessionsPerUser",
    "shippingAmount",
    "taxAmount",
    "totalAdRevenue",
    "totalPurchasers",
    "totalRevenue",
    "totalUsers",
    "transactions",
    "transactionsPerPurchaser",
    "userEngagementDuration",
    "wauPerMau",
  ];

  useEffect(() => {
    const detail = async () => {
      /* eslint-disable no-unused-vars */
      const result = await analyticsReport(
        time,
        fromDate,
        toDate,
        sMetrics,
        sDiam,
        search,
        number
      ).then(
        (result) => {
          setDetail(result.rows);
          setDHeader(result.dimensionHeaders);
          setMHeader(result.metricHeaders);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
    };
    detail();
    // eslint-disable-line react-hooks/exhaustive-deps
    //eslint-disable-next-line
  }, [number, time, search, sMetrics, sDiam]);
  const update = () => {
    setLoading(true);
    setTime("7daysAgo");
  };
  const mUpdate = () => {
    setLoading(true);
    setTime("30daysAgo");
  };
  const tMUpdate = () => {
    setLoading(true);
    setTime("90daysAgo");
  };
  //  const lUpdate = ()=>{
  //     setLoading(true);
  //     setTime('Last Quarter');
  //      }
  //      const mTDUpdate = ()=>{
  //         setLoading(true);
  //         setTime('Month To Date');
  //          }
  const TUpdate = () => {
    setLoading(true);
    setTime("today");
  };
  const yUpdate = () => {
    setLoading(true);
    setTime("yesterday");
  };
  const addNumber = async () => {
    let i = number + 1;
    setNumber(i);
    setLoading(true);
  };
  const minusNumber = async () => {
    let i = number - 1;
    setNumber(i);
    setLoading(true);
  };

  const checkDValueExist = (value, type) => {
    return sDiam.some(function (el) {
      return el.name === value;
    });
  };

  const checkMValueExist = (value, type) => {
    return sMetrics.some(function (el) {
      return el.name === value;
    });
  };

  const diamen = (event) => {
    setDiam(event.target.value);
    setSearch(false);
  };

  const sDiamen = () => {
    if (!checkDValueExist(diam, "name")) {
      setSDiam([...sDiam, { name: diam }]);
      setSearch(false);
    } else {
      toastr.error("Dimension Value Already Exist", "Error");
    }
  };

  const metric = (event) => {
    let a = [];
    // a.push(event.target.value);
    setMetrics(event.target.value);
    setSearch(false);
  };

  const sMetric = () => {
    if (!checkMValueExist(metrics, "name")) {
      setSMetrics([...sMetrics, { name: metrics }]);
      setSearch(false);
    } else {
      toastr.error("Metrics Value Already Exist", "Error");
    }
  };

  const fromDates = (event) => {
    setFromDate(event.target.value);
    setSearch(false);
  };

  const toDates = (event) => {
    setToDate(event.target.value);
    setSearch(false);
  };

  const handleDRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(sDiam);
    items.splice(index, 1);
    setSearch(false);
    setSDiam(items);
  };

  const handleMRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(sDiam);
    items.splice(index, 1);
    setSMetrics(items);
  };
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ">
                <div className="card-header filter">
                  <h3 className="card-title">Analytics report</h3>

                  <ul className="navbar-nav ml-auto ">
                    <li className="nav-item">
                      <div
                        className="float-right"
                        style={{ width: "fit-content" }}
                      >
                        <a
                          className="nav-link"
                          data-widget="navbar-search"
                          href="#!"
                          role="button"
                          onClick={(event) => {
                            event.preventDefault();
                            setSearchOn(!searchOn);
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </a>
                      </div>
                      <div
                        className="float-right"
                        style={{ width: "fit-content" }}
                        hidden={searchOn === false}
                      >
                        <a
                          className="nav-link"
                          data-widget="navbar-search"
                          href="#!"
                          role="button"
                          onClick={(event) => {
                            event.preventDefault();
                            setSearch(false);
                            setSearchOn(false);
                          }}
                        >
                          <i className="fas fa-times"></i>
                        </a>
                      </div>
                      <div
                        className={
                          searchOn
                            ? "navbar-search-block"
                            : "navbar-search-block none"
                        }
                        style={{ width: "fit-content" }}
                      >
                        <form
                          className="form-row"
                          onSubmit={(event) => {
                            event.preventDefault();
                            setSearch(true);
                            setTime("");
                            setLoading(true);
                          }}
                        >
                          <div className="row mt-5">
                            <div className="col-6">
                              <div className="input-group input-group-sm">
                                <label>From</label>&nbsp;
                                <input
                                  className="form-control form-control-navbar"
                                  type="search"
                                  placeholder="yyyy-mm-dd"
                                  aria-label="yyyy-mm-dd"
                                  value={fromDate}
                                  onChange={(event) => {
                                    fromDates(event);
                                  }}
                                />
                                &nbsp;&nbsp;
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="input-group input-group-sm">
                                <label>To</label>&nbsp;
                                <input
                                  className="form-control form-control-navbar"
                                  type="search"
                                  placeholder="yyyy-mm-dd"
                                  aria-label="yyyy-mm-dd"
                                  value={toDate}
                                  onChange={(event) => {
                                    toDates(event);
                                  }}
                                />
                                <div className="col-md-2">
                                  <Button
                                    variant="light"
                                    style={{
                                      width: "100px",
                                      marginTop: "-4px",
                                      marginLeft: "2px",
                                      height: "40px",
                                    }}
                                    type="submit"
                                  >
                                    <i className="fas fa-search"></i>
                                  </Button>
                                </div>
                                <br></br>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-8 mt-5">
                            <div className="form-group">
                              <div className="row">
                                <div className="input-group input-group-sm">
                                  <div
                                    className="col-md-12"
                                    dir={lan === "rtl" ? "rtl" : "ltr"}
                                  >
                                    <div className="row">
                                      <div className="col-md-2">
                                        <label
                                          className={
                                            lan === "rtl"
                                              ? "float-right"
                                              : "float-left"
                                          }
                                        >
                                          Dimensions
                                        </label>
                                      </div>
                                      <div className="col-md-6">
                                        <input
                                          className="form-control form-control-navbar"
                                          type="search"
                                          name="name"
                                          placeholder="achievementId"
                                          aria-label="achievementId"
                                          list="dimensionData"
                                          value={diam}
                                          onChange={(event) => {
                                            diamen(event);
                                          }}
                                        />
                                        <datalist id="dimensionData">
                                          {dData.map((person, index) => (
                                            <option value={person} />
                                          ))}
                                        </datalist>
                                      </div>
                                      {/* <datalist id="ice-cream-flavors">
                                <option value="Chocolate"/>
                                <option value="Coconut"/>
                                <option value="Mint"/>
                                <option value="Strawberry"/>
                                <option value="Vanilla"/>
                                </datalist> */}
                                      <div className="col-md-2">
                                        <Button
                                          variant="light"
                                          onClick={sDiamen}
                                          style={{
                                            width: "100px",
                                            marginTop: "2px",
                                            height: "40px",
                                          }}
                                        >
                                          Add
                                        </Button>
                                      </div>
                                      <div className="col-md-2">
                                        <Button
                                          variant="light"
                                          style={{
                                            width: "100px",
                                            marginTop: "2px",
                                            height: "40px",
                                          }}
                                          type="submit"
                                        >
                                          <i className="fas fa-search"></i>
                                        </Button>
                                      </div>
                                    </div>
                                    <div
                                      className="row"
                                      style={{
                                        marginTop: "10px",
                                        backgroundColor: "#f2f2f2",
                                      }}
                                    >
                                      <div
                                        className="col-md-12"
                                        style={{
                                          marginTop: "20px",
                                          marginBottom: "20px",
                                        }}
                                      >
                                        <div className="row">
                                          {sDiam.map((person, index) => (
                                            <div
                                              className="mr-2"
                                              style={{
                                                borderRadius: "5px",
                                                backgroundColor: "#cccccc",
                                                width: "fit-content",
                                              }}
                                            >
                                              {person.name + " "}{" "}
                                              <button
                                                className="btn btn-navbar"
                                                type="button"
                                                data-widget="navbar-search"
                                                onClick={(event) =>
                                                  handleDRemove(event, index)
                                                }
                                              >
                                                <i className="fas fa-times"></i>
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-8 mt-3">
                            <div className="form-group">
                              <div className="row">
                                <div className="input-group input-group-sm">
                                  <div
                                    className="col-md-12"
                                    dir={lan === "rtl" ? "rtl" : "ltr"}
                                  >
                                    <div className="row">
                                      <div className="col-md-2">
                                        <label
                                          className={
                                            lan === "rtl"
                                              ? "float-right"
                                              : "float-left"
                                          }
                                        >
                                          Metrics
                                        </label>
                                      </div>
                                      <div className="col-md-6">
                                        <input
                                          className="form-control form-control-navbar"
                                          type="search"
                                          name="name"
                                          placeholder="activeUsers"
                                          aria-label="activeUsers"
                                          list="metricsData"
                                          value={metrics}
                                          onChange={(event) => {
                                            metric(event);
                                          }}
                                        />
                                        <datalist id="metricsData">
                                          {mData.map((person, index) => (
                                            <option value={person} />
                                          ))}
                                        </datalist>
                                      </div>
                                      <div className="col-md-2">
                                        <Button
                                          variant="light"
                                          onClick={sMetric}
                                          style={{
                                            width: "100px",
                                            marginTop: "2px",
                                            height: "40px",
                                          }}
                                        >
                                          Add
                                        </Button>
                                      </div>
                                      <div className="col-md-2">
                                        <Button
                                          variant="light"
                                          style={{
                                            width: "100px",
                                            marginTop: "2px",
                                            height: "40px",
                                          }}
                                          type="submit"
                                        >
                                          <i className="fas fa-search"></i>
                                        </Button>
                                      </div>
                                    </div>
                                    <div
                                      className="row"
                                      style={{
                                        marginTop: "10px",
                                        backgroundColor: "#f2f2f2",
                                      }}
                                    >
                                      <div
                                        className="col-md-12"
                                        style={{
                                          marginTop: "20px",
                                          marginBottom: "20px",
                                        }}
                                      >
                                        <div className="row">
                                          {sMetrics.map((person, index) => (
                                            <div
                                              className="mr-2"
                                              style={{
                                                borderRadius: "5px",
                                                backgroundColor: "#cccccc",
                                                width: "fit-content",
                                              }}
                                            >
                                              {person.name + " "}{" "}
                                              <button
                                                className="btn btn-navbar"
                                                type="button"
                                                data-widget="navbar-search"
                                                onClick={(event) =>
                                                  handleMRemove(event, index)
                                                }
                                              >
                                                <i className="fas fa-times"></i>
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <div className="col-sm-8 mt-3">
        <div className="row mt-2">
                              <div className="input-group-append">
                                <button className="btn btn-navbar" type="submit">
                                  <i className="fas fa-search"></i>
                                </button>
                                <button
                                  className="btn btn-navbar"
                                  type="button"
                                  data-widget="navbar-search"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    setSearch(false);
                                    setSearchOn(false);
                                  }}
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                              </div>
                              </div> */}
                        </form>
                      </div>
                    </li>
                    {searchOn === false && (
                      <li>
                        <div className="btn-group">
                          <button type="button" className="btn btn-default">
                            {time ? time : "Time Frame"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-default dropdown-toggle dropdown-icon"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            // disabled={editing.cloudKey&&editing.cloudSecretV2?false:true}
                          >
                            <span className="sr-only">Toggle Dropdown</span>
                          </button>
                          <div className="dropdown-menu" role="menu">
                            <button className="dropdown-item" onClick={TUpdate}>
                              Today
                            </button>
                            <button className="dropdown-item" onClick={yUpdate}>
                              Yesterday
                            </button>
                            <button
                              className="dropdown-item"
                              name="7 Days"
                              onClick={update}
                            >
                              7 Days
                            </button>
                            <button className="dropdown-item" onClick={mUpdate}>
                              30 days
                            </button>
                            <button
                              className="dropdown-item"
                              onClick={tMUpdate}
                            >
                              90 Days
                            </button>
                            {/* <button
                                            className="dropdown-item"
                                            onClick={lUpdate}
                                            >
                                              Last Quarter
                                            </button>
                                            <button
                                            className="dropdown-item"
                                            onClick={mTDUpdate}
                                            >
                                              Month to Date
                                            </button> */}
                          </div>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <div style={{ paddingBottom: "60px" }}>
                              <table
                                id="appadmin"
                                className="table table-bordered table-hover dataTable dtr-inline"
                                role="grid"
                                aria-describedby="example2_info"
                              >
                                <thead>
                                  <tr role="row">
                                    {dHeader.map((person, index) => (
                                      <th
                                        className="sorting_asc"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        {person.name
                                          .replace(/(_|-)/g, " ")
                                          .trim()
                                          .replace(/\w\S*/g, function (str) {
                                            return (
                                              str.charAt(0).toUpperCase() +
                                              str.substr(1)
                                            );
                                          })
                                          .replace(/([a-z])([A-Z])/g, "$1 $2")
                                          .replace(
                                            /([A-Z])([A-Z][a-z])/g,
                                            "$1 $2"
                                          )}
                                      </th>
                                    ))}

                                    {mHeader.map((person, index) => (
                                      <th
                                        className="sorting_asc"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        {person.name
                                          .replace(/(_|-)/g, " ")
                                          .trim()
                                          .replace(/\w\S*/g, function (str) {
                                            return (
                                              str.charAt(0).toUpperCase() +
                                              str.substr(1)
                                            );
                                          })
                                          .replace(/([a-z])([A-Z])/g, "$1 $2")
                                          .replace(
                                            /([A-Z])([A-Z][a-z])/g,
                                            "$1 $2"
                                          )}
                                      </th>
                                    ))}
                                    {/* <th
                                        className="sorting_asc"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Plays
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Ad Impressions
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Completes
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Complete Rate
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Time Watched
                                      </th> */}
                                  </tr>
                                </thead>

                                {/* {editing.cloudKey&&editing.cloudSecretV2&& */}
                                {/* <> */}
                                <tbody>
                                  {detail.map((person, index) => (
                                    <tr role="row" className="even" key={index}>
                                      {person.dimensionValues.map(
                                        (person, index) => (
                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={0}
                                          >
                                            {person.value}
                                          </td>
                                        )
                                      )}

                                      {person.metricValues.map(
                                        (person, index) => (
                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person.value}
                                          </td>
                                        )
                                      )}

                                      {/* <td
                                          className="dtr-control sorting_1"
                                          tabIndex={1}
                                          
                                        >
                                          
                                            {person[1]}
                                          
                                        </td>
                                       
                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={1}
                                        >
                                          
                                            {person[2]}
                                          
                                        </td>
                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={1}
                                        >
                                         
                                            {person[3]}
                                          
                                        </td>
                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={2}
                                        >
                                      
                                      {person[4]}
                                        </td>
                                        <td>
                                        {person[5]}
                                        </td> */}
                                    </tr>
                                  ))}
                                </tbody>
                                {/* </> */}
                                {/* // } */}
                              </table>
                              {/* {!(editing.cloudKey&&editing.cloudSecretV2)&&
                                        <>
                                        <div className="text-center mt-5">
                                           <h1> Please Enable Video Cloud</h1>
                                        </div>
                                        </>} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
                <div className="card-footer text-center">
                  {/* <button onClick={minusNumber} disabled={number===0?true:false}><i className="fas fa-angle-left "></i></button>&nbsp;{number}&nbsp;<button onClick={addNumber} disabled={detail.length<5?true:false}><i className="fas fa-angle-right"></i></button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default Analytics_Report;
